<template>
  <div class="home">
    <div class="home-main">
      <section class="section-home-top">
        <div class="home-top-project">
          <div class="home-top-project-container">
            <div class="project-title">项目概况</div>
            <div class="project-text">
              {{projectOverviewObj.content }}
            </div>
          </div>
        </div>
        <div class="home-top-resource">
          <div class="resource-search">
            <div class="search-input">
              <el-input v-model="searchValue" placeholder="请输入关键字"></el-input>
              <div class="search-button" @click="toSearchPage"><i class="el-icon-search"></i></div>
            </div>
          </div>
          <ul class="resource-main">
            <li class="resource-li" @click="toResourceBase('seed')">
              <img :src="pictureSeeds" alt="" v-if="pictureSeeds"/>
              <div class="resource-li-title" ><span v-if="pictureSeedsName">{{pictureSeedsName}}</span></div>
            </li>
            <li class="resource-li"  @click="toResourceBase('dna')">
              <img :src="pictureDna" alt="" v-if="pictureDna"/>
              <div class="resource-li-title" ><span v-if="pictureDnaName">{{pictureDnaName}}</span></div>
            </li>
            <li class="resource-li"  @click="toResourceBase('germplasmAnimal')">
              <img :src="pictureAnimalgermplasm" alt="" v-if="pictureAnimalgermplasm"/>
              <div class="resource-li-title" ><span v-if="pictureAnimalgermplasmName">{{pictureAnimalgermplasmName}}</span></div>
            </li>
            <li class="resource-li"  @click="toResourceBase('vascularPlant')">
              <img :src="pictureVascularPlant" alt="" v-if="pictureVascularPlant"/>
              <div class="resource-li-title" ><span v-if="pictureVascularPlantName">{{pictureVascularPlantName}}</span></div>
            </li>
            <li class="resource-li" @click="toResourceBase('spineAnimal')">
              <img :src="pictureSpineAnimal" alt="" v-if="pictureSpineAnimal"/>
              <div class="resource-li-title"><span v-if="pictureSpineAnimalName">{{pictureSpineAnimalName}}</span></div>

            </li>
            <li class="resource-li" @click="toResourceBase('scientific')">
              <img :src="pictureDriedLeaf" alt="" v-if="pictureDriedLeaf"/>
              <div class="resource-li-title" ><span v-if="pictureDriedLeafName">{{pictureDriedLeafName}}</span></div>

            </li>
            <li class="clear"></li>
          </ul>
        </div>
        <div class="clear"></div>
      </section>
      <section class="section-home-container">
        <div class="home-container-left" >
          <el-carousel height="300px" :interval="3000" arrow="always" indicator-position="none">
            <el-carousel-item v-for="(item, index) in processImgList" :key="index" >
             <div  @click="toProcessDetail(item)">
               <img :src="item.url" alt="" />
               <div class="home-container-left-title">{{item.title}}</div>
             </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="home-container-right">
          <el-tabs v-model="activeName">
            <el-tab-pane label="动态资讯" name="first" >
              <div class="home-container-body" v-for="(item, index) in informationList" :key="item.id" @click="toDynamic(item)">
                <div class="home-container-body-title">{{ item.title }}</div>
                <div class="home-container-body-date">{{ item.createTime }}</div>
              </div>
              <div class="home-container-more" @click="toDynamicList">查看更多</div>
            </el-tab-pane>
            <el-tab-pane label="工作进展" name="second">
              <div class="home-container-body" v-for="(item, index) in processList" :key="item.id" @click="toDynamicTitle(item)">
                <div class="home-container-body-title">{{ item.title }}</div>
                <div class="home-container-body-date">{{ item.createTime }}</div>
              </div>
              <div class="home-container-more" @click="toDynamicProList">查看更多</div>
            </el-tab-pane>
            <el-tab-pane label="标准规范" name="third">
              <div class="home-container-body" v-for="(item, index) in standardSpecificationList" :key="item.id" @click="toDynamicTitle(item)">
                <div class="home-container-body-title">{{ item.title }}</div>
                <div class="home-container-body-date">{{ item.createTime }}</div>
              </div>
                <div class="home-container-more" @click="toDynamicStandardSpecification">查看更多</div>
            </el-tab-pane>
            <el-tab-pane label="帮助文档" name="fourth">
              <div class="home-container-body" v-for="(item, index) in helpDocumentsList" :key="item.id" @click="toDynamicTitle(item)">
                <div class="home-container-body-title">{{ item.title }}</div>
                <div class="home-container-body-date">{{ item.createTime }}</div>
              </div>
              <div class="home-container-more" @click="toDynamicHelpDocuments">查看更多</div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="clear"></div>
      </section>
    </div>
  </div>
</template>

<script>
import {getResourceBasePicture} from "@/network/home";
import navBar from '@/components/navBar/homeNav'
import {getDynamicHomeImg, information, pictureVideoInfo, progressWorkInfo} from "@/network/detailCom";
import {cooperativeunit} from "@/network/cooperativeunit";
import {getProjectOverviewList} from "@/network/projectOverview";
import {standardSpecification} from "@/network/dynamic/standardSpecification";
import {helpDocuments} from "@/network/dynamic/helpDocuments";
export default {
  name: "Page",
  components: { navBar },
  data() {
    return {
      swiperList: [],
      activeName: 'first',
      firstImg: '',
      firstImgProgress: '',
      InformationType:'information',
      processType: 'progressWork',
      videoType: 'picture',
      editorProcessImg: {},//工作进展图片列表
      editorInformationImg: {},
      informationList: [],
      processList: [],
      //---------------种质资源库
      pictureSeeds: '',
      pictureDna: '',
      pictureAnimalgermplasm: '',
      pictureVascularPlant: '',
      pictureSpineAnimal: '',
      pictureDriedLeaf: '',
      pictureSeedsName: '',
      pictureAnimalgermplasmName: '',
      pictureDnaName: '',
      pictureSpineAnimalName: '',
      pictureVascularPlantName: '',
      pictureDriedLeafName: '',
      //---------科考影响
      showVideo: {},
      editorText: '',
      //项目合作单位
      projectList: [],
      page: 1,
      pageSize: 6,
      totalPage: 10,
      certification: '',
      token: '',
      //--------项目概况
      projectOverviewObj: {},
      standardSpecificationList: [],
      helpDocumentsList: [],
      processImgList: [],
      searchValue: '',

    }
  },
  mounted() {
    // this.certification  = JSON.parse(localStorage.getItem('certification'))
    // this.token   = localStorage.getItem('access_token');
    this.getResourceBase()
    this.getInformation()
    this.getProgressWork()
    this.getVideoInfo()
    this.getProjectList()
    this.getProjectOverviewList()
    this.getStandardSpecification()
    this.getHelpDocuments()
  },
  methods: {
    /**
     * 去搜索页面
     */
    toSearchPage() {
      // console.log(this.searchValue)
      this.$router.push({ path: '/searchPage', query: { title: this.searchValue } })
    },
    /**
     * 标准规范
     */

    /**
     * 项目概况
     */
    getProjectOverviewList() {
      getProjectOverviewList('projectOverview').then(res => {
        // console.log(res)
        this.projectOverviewObj = res.data.data.records[0]
      })
    },
    /**
     * 库
     */
    getResourceBase() {
      getResourceBasePicture().then(res => {
        // console.log('5464564',res)
        this.swiperList = res.data.data.shufflingPictureList
        this.pictureSeeds = res.data.data.pictureSeeds.url //种子
        this.pictureSeedsName = res.data.data.pictureSeeds.name.split('.')[0] //种子
        this.pictureAnimalgermplasm = res.data.data.pictureAnimalgermplasm.url //动物种质
        this.pictureAnimalgermplasmName = res.data.data.pictureAnimalgermplasm.name.split('.')[0]  //动物种质
        this.pictureDna = res.data.data.pictureDna.url //非种子植物种质
        this.pictureDnaName = res.data.data.pictureDna.name.split('.')[0]  //非种子植物种质
        this.pictureSpineAnimal = res.data.data.pictureSpineAnimal.url //动物DNA条形码
        this.pictureSpineAnimalName = res.data.data.pictureSpineAnimal.name.split('.')[0]  //动物DNA条形码
        this.pictureVascularPlant = res.data.data.pictureVascularPlant.url //植物DNA条形码
        this.pictureVascularPlantName = res.data.data.pictureVascularPlant.name.split('.')[0]  //植物DNA条形码
        this.pictureDriedLeaf = res.data.data.pictureDriedLeaf.url //植物DNA条形码
        this.pictureDriedLeafName = res.data.data.pictureDriedLeaf.name.split('.')[0]  //植物DNA条形码

      })
    },
    getInformation() {
      information(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.InformationType
      })).then(response => {
        // console.log(response)
        this.informationList = response.data.data.records
        this.totalPage = response.data.data.total
      })
      getDynamicHomeImg({type: 'information'}).then(res => {
        // console.log('getDynamicHomeImg',res)
        if(res.data.code == 0) {
          this.editorInformationImg = res.data.data
          this.firstImg = res.data.data.imgSrc[0]
        }
      })
    },
    getProgressWork() {
      progressWorkInfo(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.processType
      })).then(response => {
        this.processList = response.data.data.records
        this.totalPage = response.data.data.total
        // console.log(this.processList)
        for(let i = 0; i < this.processList.slice(0, 4).length; i++) {
          let content = this.processList[i].content
          let title = this.processList[i].title
          let id = this.processList[i].id
          let type = this.processList[i].type
          let matches = content.match(/<img.*?src="(.*?)".*?>/g);
          if (matches) {
            for (let j = 0; j < matches.length; j++) {
              let match = matches[j];
              let imageUrl = match.match(/<img.*?src="(.*?)".*?>/)[1];
              let obj = {
                url: imageUrl,
                title: title,
                id: id,
                type: type
              }
              this.processImgList.push(obj);
            }
          }
        }
        // console.log('657575',this.processImgList)
      })
    },
    getStandardSpecification(){
      standardSpecification(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: 'standardSpecification'
      })).then(res => {
        // console.log(res)
        this.standardSpecificationList = res.data.data.records

      })
    },
    getHelpDocuments(){
      helpDocuments(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: 'helpDocuments'
      })).then(res => {
        // console.log(res)
        this.helpDocumentsList = res.data.data.records

      })
    },
    /**
     * 左侧轮播图点击到工作进展详情
     * @param item
     */
    toProcessDetail(item) {
      this.$router.push('/detail/'+ item.id + '/' + item.type)
/*
      if(this.token) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      }else {
        this.$message.error('你还未登录，请先登录！')
      }
      */
    },
    //去动态资讯列表页
    toDynamicList() {
      this.$router.push('/dynamic/information')
    },
    //去动态资讯详情
    toDynamicInfo(item) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      /*if(this.token) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      }else {
        this.$message.error('你还未登录，请先登录！')
      }
   */
    },
    //标题去动态资讯详情
    toDynamic(item) {
        this.$router.push('/detail/'+ item.id + '/' + item.type)
      // if(this.token) {
      //   this.$router.push('/detail/'+ item.id + '/' + item.type)
      // }else {
      //   this.$message.error('你还未登录，请先登录！')
      // }
    },
    toDynamicProList() {
      this.$router.push('/dynamic/progressWork')
    },
    toDynamicStandardSpecification(){
      this.$router.push('/dynamic/standardSpecification')
    },
    toDynamicHelpDocuments(){
      this.$router.push('/dynamic/helpDocuments')
    },
    //去工作进展详情
    toDynamicPro(item){
        this.$router.push('/detail/' + item.id + '/' + item.type)
      // if(this.token) {
      //   this.$router.push('/detail/' + item.id + '/' + item.type)
      // }else  {
      //   this.$message.error('你还未登录，请先登录！')
      // }
    },
    toDynamicTitle(item) {
        this.$router.push('/detail/' + item.id + '/' + item.type)
      // if(this.token) {
      // }else  {
      //   this.$message.error('你还未登录，请先登录！')
      // }
    },

    //植物资源库
    toResourceBase(val) {
      // if(this.certification === '2' && this.token) {
        if(val === 'protectList') {
          this.$router.push('/resourceBase/list/protectList')
        }else if(val === 'uniqueList') {
          this.$router.push('/resourceBase/list/uniqueList')
        }else if(val === 'seed') {
          this.$router.push('/resourceBase/germplasm/seed')
        }else if(val === 'dna') {
          this.$router.push('/resourceBase/germplasm/dna')
        }else if(val === 'driedLeaf') {
          this.$router.push('/resourceBase/germplasm/driedLeaf')
        }else if(val === 'germplasmAnimal') {
          this.$router.push('/resourceBase/germplasm/germplasmAnimal')
        }else if(val === 'management') {
          this.$router.push('/resourceBase/workGuide/management')
        }else if(val === 'filling') {
          this.$router.push('/resourceBase/workGuide/filling')
        }else if(val === 'spineAnimal') {
          this.$router.push('/resourceBase/dnaBar/spineAnimal')
        }else if(val === 'vascularPlant') {
          this.$router.push('/resourceBase/dnaBar/vascularPlant')
        }else if(val === 'scientific') {
          this.$router.push('/scientificResearch/picture')
        }
      // }else if(!this.token){
      //   this.$message.error('你还未登录，请先登录')
      // }else if(this.token && this.certification !== '2') {
      //   this.$message.error('你还未实名认证，无权查看该内容,请先实名认证！')
      // }

    },
    //科考影像
    getEditorText(str){
      this.editorText = str.replace(/<[^>]+>/g, "")
      return this.editorText
    },
    getVideoInfo() {
      pictureVideoInfo(Object.assign({
        current: this.page,
        size: 1,
        type: this.videoType
      })).then(response => {
        // console.log(response)
        this.videoList = response.data.data.records
        this.getEditorText(this.videoList[0].content)
        // this.fn(this.videoList[0].content)
        this.showVideo = this.videoList[0]
      })
    },
    //科考影像查看更多
    toScientific() {
        this.$router.push('/scientificResearch/picture')
      // if(this.token && this.certification == '2') {
      //   this.$router.push('/scientificResearch/picture')
      // } else if(!this.token) {
      //   this.$message.error('还未登录，请先登录！')
      // }else if(this.token && this.certification !=='2') {
      //   this.$message.error('你还未实名认证，请先实名认证！')
      // }
    },
  //  项目合作单位
    getProjectList() {
      cooperativeunit().then(res => {
        // console.log(res)
        this.projectList = res.data.data.records
        this.projectList =  res.data.data.records.slice(0,5)
      })
    },
    //去项目合作单位的链接
    toLink(link) {
      // console.log(123,link)
      window.open(link,'_blank')
    },
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/page.scss";
.home .home-main .section-home-top .home-top-project {
  position: relative;
  overflow: hidden;

}
.home .home-main .section-home-top .home-top-project .project-text[data-v-5a7b936e] {
  position: absolute; /* 绝对定位 */
  top: 40px;
  left: 0;
  //width: 264px;
  padding: 0px 10px;
  text-align: justify;
  max-height: calc(1.2em * 22) !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre-line;
  display: block;
}
::v-deep .el-input__inner {
  border-radius: 0 !important;
  height: 45px !important;
  //border-bottom-right-radius: 0 !important;
}

</style>